import { BiMap, BiMapAlt } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setCardDetail } from "../../redux/slice/cardDetailSlice";
import { normalizeListingDetail } from "../../utils/normalizeListingDetail";
import { scrollPageToTop } from "../../utils/scrollToTop";
import CardHoverIcons from "./CardHoverIcons";

const listingImageSrc = (card) => {
  const path = card?.images?.[0] || card?.imagesFullPath?.[0] || "";
  if (!path) return "";
  if (typeof path === "string" && path.startsWith("http")) return path;
  return `https://imaj.emlakjet.com/original${path}`;
};

const SingleCheapAdvertCard = ({ card, className = "", compact = false }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const goToDetail = (e) => {
    e?.preventDefault?.();
    e?.stopPropagation?.();
    dispatch(setCardDetail(normalizeListingDetail(card)));
    history.push(`/advert/${card.id}`);
    requestAnimationFrame(() => scrollPageToTop());
  };

  const formatlaTL = (fiyat) => {
    const formattedFiyat = new Intl.NumberFormat("tr-TR", {
      currency: "TRY",
      minimumFractionDigits: 2,
    }).format(fiyat);
    return formattedFiyat.slice(0, -3);
  };

  const wrapperClass =
    className ||
    "w-full min-w-0 max-w-full shadow-light dark:border-card-dark border rounded-lg overflow-hidden relative group cursor-pointer";

  return (
    <article
      className={wrapperClass}
      onClick={goToDetail}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          goToDetail(e);
        }
      }}
      role="link"
      tabIndex={0}
      aria-label={`${card.title} ilan detayı`}
    >
      <div>
        <div className="group !opacity-100 overflow-hidden relative">
          <img
            src={listingImageSrc(card)}
            alt="ilan"
            className={`w-full object-cover group-hover:scale-110 transition-a ${
              compact ? "h-[140px] sm:h-[180px]" : "h-[200px] sm:h-[250px]"
            }`}
          />
          <CardHoverIcons />
          <div className="absolute bottom-0 left-0 w-full px-2 py-2 transition-transform bg-gradient-to-t from-black/80 sm:translate-y-10 group-hover:translate-y-0 to-transparent">
            <div className="text-white flex-align-center gap-x-2">
              <BiMap />
              <p>{card.location.city.name}</p>
            </div>
          </div>
        </div>
        <div className="absolute top-2 left-2 right-2">
          <span className="block py-[2px] px-2 text-[10px] sm:text-xs rounded-full text-white bg-secondary line-clamp-2 leading-tight">
            {card.tradeTypeName} / {card.categoryTypeName}
          </span>
        </div>
        <div className={`${compact ? "p-2" : "p-3"} min-w-0`}>
          <h2 className={`font-bold capitalize line-clamp-2 ${compact ? "text-sm" : "text-lg"}`}>
            {card.title}
          </h2>
          <p className={`text-muted mt-2 line-clamp-2 ${compact ? "text-[11px]" : "text-sm"}`}>
            {card.location?.city?.name} · {card.location?.district?.name}
          </p>
          <div className={`mt-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between ${compact ? "" : ""}`}>
            <p className={`font-semibold text-primary shrink-0 ${compact ? "text-sm" : "text-lg"}`}>
              {formatlaTL(card.priceDetail?.price ?? card.price)} TL
            </p>
            <button
              type="button"
              onClick={goToDetail}
              className={`btn btn-secondary shrink-0 ${compact ? "text-xs py-1 px-2" : ""}`}
            >
              Detay
            </button>
          </div>
        </div>
      </div>
    </article>
  );
};

export default SingleCheapAdvertCard;
